import { useClassStore } from '@Utils/useClassStore';
import { inject, injectable } from 'inversify';
import { action, computed } from 'mobx';

import container from '../../ioc/ioc';

import { JourneysStore } from '~stores/journeys';
import ProductsStore from '~stores/products';
import type { IProductOption } from '~types/models-types';

@injectable()
export class ProductsPresenter {
  @inject(JourneysStore)
  private journeysStore!: JourneysStore;
  @inject(ProductsStore)
  private ProductsStore!: ProductsStore;

  @computed
  get currentProductPriceForOption(): number | null | undefined {
    if (!this.ProductsStore.currentProduct) {
      return undefined;
    }
    if (!this.ProductsStore.currentProductSelectedOption) {
      return this.ProductsStore.currentProduct.price;
    }
    if (
      this.ProductsStore.currentProductSelectedOption.price === undefined ||
      this.ProductsStore.currentProductSelectedOption.price === null
    ) {
      return this.ProductsStore.currentProduct.price;
    }
    return this.ProductsStore.currentProductSelectedOption.price;
  }

  @computed
  get currentProductImagesForOption(): string[] {
    if (!this.ProductsStore.currentProduct) {
      return [];
    }

    if (!this.ProductsStore.currentProductSelectedOption) {
      return this.ProductsStore.currentProduct.mediaUrls;
    }

    if (!this.ProductsStore.currentProductSelectedOption.imageUrl) {
      return this.ProductsStore.currentProduct.mediaUrls;
    }

    return [
      this.ProductsStore.currentProductSelectedOption.imageUrl,
      ...this.ProductsStore.currentProduct.mediaUrls,
    ];
  }

  @action handleProductOptionSelect = (productOption: IProductOption) => {
    this.ProductsStore.currentProductSelectedOption = productOption;
    this.ProductsStore.uiProductDetailOptionMenuOpen = false;
  };
}

const useProductsPresenter = () =>
  useClassStore<ProductsPresenter>(container.get(ProductsPresenter));

export default useProductsPresenter;
